import { type TypedDocumentNode, gql } from '@apollo/client';
import type { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';

import { TrendingPlayer } from 'components/player/TrendingPlayer';

import { HeaderSection } from '../HeaderSection';
import { SlideShow } from '../SlideShow';
import type { TrendingPlayers_anyPlayer } from './__generated__/index.graphql';

type Props = {
  players: Nullable<
    {
      player: TrendingPlayers_anyPlayer;
      tradesCount: number;
    }[]
  >;
  onMarketClick: (slug: string) => void;
  track?: ComponentProps<typeof TrendingPlayer>['track'];
};

export const TrendingPlayers = ({ players, onMarketClick, track }: Props) => {
  if (!players?.length) {
    return null;
  }
  return (
    <Vertical gap={3}>
      <HeaderSection
        title={
          <FormattedMessage
            id="TrendingPlayers.title"
            defaultMessage="Trending Players"
          />
        }
      />
      <SlideShow>
        <Horizontal gap={1.5}>
          {players.map(({ player, tradesCount }) => (
            <TrendingPlayer
              key={player.slug}
              anyPlayer={player}
              tradesCount={tradesCount}
              onMarketClick={slug => {
                onMarketClick(slug);
              }}
              track={track}
            />
          ))}
        </Horizontal>
      </SlideShow>
    </Vertical>
  );
};

TrendingPlayers.fragments = {
  anyPlayer: gql`
    fragment TrendingPlayers_anyPlayer on AnyPlayerInterface {
      slug
      ...TrendingPlayer_anyPlayer
    }
    ${TrendingPlayer.fragments.anyPlayer}
  ` as TypedDocumentNode<TrendingPlayers_anyPlayer>,
};
